// tslint:disable:member-ordering
// tslint:disable-next-line:no-namespace
module ProcessList {
    "use strict";
    import IModalService = angular.ui.bootstrap.IModalService;
    import IModalSettings = angular.ui.bootstrap.IModalSettings;
    import IFrendsResult = Shared.IFrendsResult;
    import EnvironmentsDataService = Shared.Environments.EnvironmentsDataService;
    import IEnvironmentData = Shared.Environments.IEnvironmentData;
    import IAllEnvironmentNames = Shared.Environments.IAllEnvironmentNames;

    export class ProcessStatus {
        public deployingToAgents: string[] = [];
        public missingTriggers: string[] = [];
        public isDeploying: boolean;
        public hasMissingTriggers: boolean;
    }


    // tslint:disable-next-line:max-classes-per-file
    export class ProcessListController {
        private environments: IEnvironmentData[];
        public allEnvironmentNames: IAllEnvironmentNames[];
        public currentEnvironmentName: string;
        public currentAgentGroupName: string;
        public firstAgentName: string;
        private processFilters: IProcessListQuery;
        private processInstanceFilters: IProcessInstanceQuery;
        public processes: IProcessViewData[] = [];
        public shownProcesses: IProcessViewData[] = [];
        public processDrafts: IDraftViewData[] = [];
        public filterString: string;
        public timelimitDays: string;
        public orderByField = "name";
        public reverseSort = false;
        public allTags: string[];
        public allChecked: boolean;
        public allAutoCompleteItems: ISelectedSearchItem[];
        public selectedItems: ISelectedSearchItem[] = [];
        public availableLoggingLevels: string[];
        public activeProcessId: number;
        public toggleAdvancedFilter: boolean;
        public agentStatuses: AgentStatus[] = [];

        private offlineAgents: AgentStatus[] = [];

        public totalShownProcessesCount: number;
        public currentProcessPage: number = 1;
        public shownProcessesPerPage: number = 15;

        static $inject = ["ProcessDataService", "ProcessInstanceListService", "ProcessNotificationsHubService", "$rootScope",
            "$stateParams", "$uibModal", "EnvironmentsDataService", "notifications", "TagService", "ProcessCountsService", "$q",
            "$state", "$window", "AgentNotificationsHubService", "AgentStatusService", "$timeout", "$scope"];

        constructor(private processService: ProcessDataService,
            private processInstanceListService: ProcessInstanceListService,
            processNotificationsHub: ProcessNotificationsHubService,
            private $rootScope: ng.IRootScopeService,
            $stateParams: IProcessListStateParams,
            private $modal: IModalService,
            environmentsService: EnvironmentsDataService,
            private notifications: INotifications,
            private tagParsingService: ITagService,
            private processCountsService: ProcessCountsService,
            private $q: ng.IQService,
            private $state: angular.ui.IStateService,
            private $window: ng.IWindowService,
            private agentNotificationsHub: AgentNotificationsHubService,
            private agentStatusService: AgentStatusService,
            private $timeout: ng.ITimeoutService,
            private $scope: ng.IScope) {

            $rootScope.$broadcast("loadingspinner.manual.spin");

            var clearProcessNotificationHandler = $rootScope.$on("processNotification", () => {
                this.refreshProcesses();
                this.updateAgentStatusData(); // process updated -> update status regarding to agents
            });

            var clearProcessCountNotificationHandler = $rootScope.$on("processList.countsUpdated.frends", () => {
                this.processCountsService.getProcessCounts(this.currentEnvironmentName, this.currentAgentGroupName, this.getTimeLimit())
                    .then(data => this.updateProcessCounts(data));
            });

            var clearAgentStatusNotificationHandler = $rootScope.$on("agentStatusNotification", (event, data: AgentStatus[]) => {
                this.agentStatuses = data;
                this.updateAgentStatusData();
            });

            this.availableLoggingLevels = Shared.getEnumNames(ProcessLoggingLevel);

            this.currentProcessPage = $stateParams.processPage || 1;
            this.filterString = $stateParams.filter;
            this.selectedItems = this.tagParsingService.getTagsArray($stateParams.tag).map(tag => <ISelectedSearchItem>{ fullName: tag, groupBy: "Tag", identifier: tag, name: tag, title: tag, type: SearchItemType.Tag });
            this.toggleAdvancedFilter = !_.isEmpty(this.selectedItems)
            this.orderByField = $stateParams.orderByField ? $stateParams.orderByField : 'name';
            this.reverseSort = $stateParams.reverseSort ? ($stateParams.reverseSort === "false" ? false : true) : false;
            this.timelimitDays = $stateParams.timelimit ? $stateParams.timelimit : '7';
            this.firstAgentName = "";

            processCountsService.getInitialProcessCounts(this.getTimeLimit());

            environmentsService.all().then(data => {
                this.initializeEnvironmentsAndUpdateData(data, $stateParams.environmentName, $stateParams.highlightProcess);
                return true;
            });

            $scope.$on("$destroy", () => {
                if (clearProcessNotificationHandler) {
                    clearProcessNotificationHandler();
                }
                if (clearProcessCountNotificationHandler) {
                    clearProcessCountNotificationHandler();
                }
                if (clearAgentStatusNotificationHandler()) {
                    clearAgentStatusNotificationHandler();
                }
            });
        }

        private get processQueryFilter(): IProcessListQuery {
            return {
                environmentName: this.currentEnvironmentName,
                agentGroupName: this.currentAgentGroupName,
                timeLimit: 0
            };
        }
        private getTimeLimit(): number {
            let parsed = parseInt(this.timelimitDays);
            if (_.isNaN(parsed)) {
                return 0;
            }
            return parsed;
        }

        public filterEnumName = (value: SearchItemType) => SearchItemType[value];

        public getProcessInstanceFilterByName(name: string) {
            return ProcessInstanceFilter[name];
        }

        private initializeEnvironmentsAndUpdateData(environments: IEnvironmentData[], selectedEnvFromParams: string, initialHighlightedProcess?: number) {
            this.environments = environments;
            this.allEnvironmentNames = _.map(environments, e => { return { name: e.name, displayName: e.displayName } });
            this.currentEnvironmentName = selectedEnvFromParams;

            if (!_.some(this.allEnvironmentNames, e => e.name === this.currentEnvironmentName)) {
                this.$state.go("environment", { environmentName: EnvironmentVariables.DEFAULT_ENV_NAME });
            }
            this.findFirstAgentName(environments);
            this.agentNotificationsHub.changeSubscribedEnvironment(this.currentEnvironmentName);
            this.updateData(initialHighlightedProcess);
        }

        private findFirstAgentName(environments: IEnvironmentData[]) {
            var currentEnv = _.find(environments, (env) => {
                return env.name === this.currentEnvironmentName;
            });

            if (currentEnv.agentGroups.length > 0) {
                var firstGroup = _.first(currentEnv.agentGroups);
                this.currentAgentGroupName = firstGroup.name;
                if (firstGroup.executionAgents.length > 0) {
                    this.firstAgentName = _.first(firstGroup.executionAgents).name;
                }
            }
        }
        public getActive(id) {
            console.log(id)
            return id;
        }
        public getTriggerUri(processGuid: string) {
            if (this.firstAgentName !== "") {
                return `Environment/${this.currentEnvironmentName}/${this.currentAgentGroupName}/agent/${this.firstAgentName}/process/${processGuid}`;
            }
            return `Environment/${this.currentEnvironmentName}/${this.currentAgentGroupName}`;

        }

        public showProcessInstanceList(processId: number) {
            this.activeProcessId = processId;
        }

        public goToEditor(processId: number) {
            this.$window.location.href = `Process/Edit/${processId}`;
        }

        public updateData(initialHighlightedProcess?: number) {

            var processCounts = this.processCountsService.getProcessCounts(this.currentEnvironmentName, this.currentAgentGroupName, this.getTimeLimit());

            this.$q.all([this.processService.getProcesses(this.processQueryFilter),
            this.agentStatusService.getAgentStatuses(this.currentAgentGroupName, this.currentEnvironmentName).catch(reason => ""/* do nothing, the error was already reported by the status service*/)])
                .then(data => {
                    let processResponse = <IFrendsResult<IProcessListData>>data[0];
                    let agentStatuses = <AgentStatus[]>data[1];
                    if (!processResponse.success) {
                        this.notifications.error(processResponse.errorMessage);
                    } else {
                        this.processes = processResponse.data.processList;
                        this.processDrafts = processResponse.data.draftList;

                        this.agentStatuses = agentStatuses;
                        this.uncheckAll();

                        this.agentStatuses = agentStatuses;

                        this.uncheckAll();

                        var allTasks = _.uniqBy(_.flatten(this.processes.map(p => p.usedTasks)), "uri");

                        this.allTags = _.uniq(_.flatten(this.processes
                            .map((p) => this.tagParsingService.getTagsArray(p.tagString))));

                        this.allAutoCompleteItems = this.allTags.map(x => { return <ISelectedSearchItem>{ name: x, groupBy: FRENDS.Localizations.Tag, identifier: x, fullName: x, title: x, type: SearchItemType.Tag } })
                            .concat(allTasks.map(x => {
                                return <ISelectedSearchItem>{
                                    name: x.name, groupBy: x.packageName, identifier: x.uri, fullName: x.fullName,
                                    title: `${FRENDS.Localizations.Task}: ${x.fullName}\n${FRENDS.Localizations.Task_Package}: ${x.packageName}`,
                                    type: SearchItemType.Task
                                }
                            }));

                        for (var x = 0; x < this.processDrafts.length; x++) {
                            for (var i = 0; i < this.processes.length; i++) {
                                if (this.processDrafts[x].processId === this.processes[i].id) {
                                    this.processes[i].draftId = this.processDrafts[x].id;
                                    this.processDrafts[x].hasProcess = true;
                                }
                            }
                        }


                        this.updateAgentStatusData();

                        this.$rootScope.$broadcast("loadingspinner.manual.stop");

                        if (this.processCountsService.promiseIsReady) {
                            processCounts.then(data => {
                                let countsData = <IGroupedProcessExecutionCounts> data;
                                this.updateProcessCounts(countsData);
                                this.updateFilterAndSort(initialHighlightedProcess);
                            }).catch(reason => "");
                        } else {
                            this.updateFilterAndSort(initialHighlightedProcess);
                            processCounts.then(data => {
                                let countsData = <IGroupedProcessExecutionCounts>data;
                                this.updateProcessCounts(countsData);
                            }).catch(reason => "");
                        }
                    }
                });
        }
        // Friendly(er) name for tasks, so the dropdown doesnt show package name for each task
        public getTaskLabel(taskName: string) {
            if (!taskName) { return ""; }
            let taskNameParts = taskName.split(".");
            return taskNameParts.splice(taskNameParts.length - 2).join(".");
        }
        public toggleFilterChange(toggleAdvanced: boolean) {
            if (toggleAdvanced) {
                this.filterString = "";
                this.toggleAdvancedFilter = toggleAdvanced;
            } else {
                this.selectedItems = [];
                this.toggleAdvancedFilter = toggleAdvanced;
            }
            this.updateFilterAndSort();
        }

        public isCurrent(env: string) {
            return env === this.currentEnvironmentName;
        };

        public isDefault() {
            return this.currentEnvironmentName === EnvironmentVariables.DEFAULT_ENV_NAME;
        };
        public changeSort(column) {
            this.orderByField = column;
            this.reverseSort = !this.reverseSort;
            this.currentProcessPage = 0;
            this.updateFilterAndSort();
        };

        public changePage = () => this.updateFilterAndSort();

        public getVersionsInfo(process: IProcessData) {
            var title = "";
            _.each(process.existingVersions, deployedV => {
                _.each(deployedV.deployedProcessVersions, v => {
                    title += v.environmentName + ": " + deployedV.majorVersion + "." + deployedV.minorVersion + "." + v.versionNumber + "\n";
                });
            });
            return title;
        };

        public getSelectedProcesses() {
            return _.filter(this.shownProcesses, p => p.checked);
        };

        public toggleCheckAll() {
            this.shownProcesses.forEach(p => p.checked = this.allChecked && this.matchesFilter(p));
        };

        public uncheckAll() {
            this.allChecked = false;
            this.toggleCheckAll();
        };

        public openSwitchVersionModal(selectedProcesses: IProcessViewData[]) {
            this.openDeployModal(selectedProcesses, true);
        }

        public openDeployModal(selectedProcesses: IProcessViewData[], switchVersion: boolean) {
            var deployModal = this.$modal.open({
                templateUrl: "deployModalTemplate",
                windowClass: "default-modal-styles",
                resolve: {
                    processes: () => selectedProcesses,
                    environments: () => this.environments,
                    currentEnvironment: () => this.currentEnvironmentName,
                    currentAgentGroup: () => this.currentAgentGroupName,
                    isSwitchVersion: () => switchVersion
                },
                controller: "DeployProcessesModalController as ctrl"
            });

            deployModal.result.then(r => this.updateData());
        };

        public openRunOnceModal(selectedProcess: IProcessViewData) {
            var runOnceModal = this.$modal.open({
                templateUrl: "runOnceModal",
                windowClass: "default-modal-styles",
                resolve: {
                    manualTriggerParameters: () => selectedProcess.manualTriggerParameters,
                },
                controller: "RunOnceModalController as ctrl"
            });

            runOnceModal.result.then(r => this.runOnce([selectedProcess], r));
        };

        public deleteProcesses(processesToDelete: IProcessViewData[]) {
            var deleteConfirmationModal = this.$modal.open({
                templateUrl: "deleteProcessModalTemplate",
                windowClass: "default-modal-styles",
                resolve: {
                    processes: () => processesToDelete,
                    currentEnvironmentName: () => this.currentEnvironmentName,
                    currentAgentGroupName: () => this.currentAgentGroupName,
                    allEnvironmentNames: () => this.allEnvironmentNames
                },
                controller: "DeleteProcessModalController as ctrl"
            });

            deleteConfirmationModal.result.then(r => this.updateData());
        };

        public getExportLink = (selectedProcesses: IProcessViewData[]) => {
            var params = "?type=Process";
            _.each(selectedProcesses, p => params += "&ids=" + p.id);
            return "Export/Export" + params;
        };

        private requestSuccessCallback = (response: IFrendsResult<string>) => {
            if (response && response.data) {
                this.notifications.notify(response.data);
                this.updateData();
            }
        };

        public copyProcesses(selectedProcesses: IProcessViewData[]) {
            var postData = { id: selectedProcesses.map(p => p.id) };
            this.processService.genericBatchAction(postData, "Process/Copy")
                .then(this.requestSuccessCallback);
        };

        public changeProcessesActivity(selectedProcesses: IProcessViewData[], activate: boolean) {
            var postData = { id: selectedProcesses.map(p => p.id), environmentName: this.currentEnvironmentName, agentGroupName: this.currentAgentGroupName };
            this.processService.genericBatchAction(postData, activate ? "Process/ActivateProcesses" : "Process/DeactivateProcesses")
                .then(this.requestSuccessCallback);
        };

        public saveEnvironmentLevelLogSettings(logLevel: ProcessLoggingLevel, historyStorageDays: number, logTriggerRequestAndResponse: boolean) {
            const postData = {
                environmentName: this.currentEnvironmentName,
                logLevel: logLevel,
                historyStorageDays: historyStorageDays,
                logTriggerRequestAndResponse: logTriggerRequestAndResponse
            };
            return this.processService.genericBatchAction(postData, "Process/SaveEnvironmentLevelLogSettings")
                .then(this.requestSuccessCallback);
        }

        public saveLogSettings(selectedProcesses: IProcessViewData[], logLevel: ProcessLoggingLevel, historyStorageDays: number, logTriggerRequestAndResponse: boolean) {
            const postData = {
                ids: selectedProcesses.map((p) => p.id),
                environmentName: this.currentEnvironmentName,
                logLevel: logLevel,
                historyStorageDays: historyStorageDays,
                logTriggerRequestAndResponse: logTriggerRequestAndResponse
            };
            return this.processService.genericBatchAction(postData, "Process/SaveLogSettings")
                .then(this.requestSuccessCallback);
        }

        public runOnce(selectedProcesses: IProcessViewData[], triggerData: any = null) {
            var postData = { processIds: selectedProcesses.map(p => p.id), environmentName: this.currentEnvironmentName, agentGroupName: this.currentAgentGroupName, triggerData: triggerData };
            var disableSpinner = true;
            this.processService.genericBatchAction(postData, "Process/RunOnce", disableSpinner)
                .then(response => {
                    if (response && response.data) {
                        // just notify the user, do not update processes - they should update later automatically
                        this.notifications.notify(response.data);
                    }
                });
        };

        public discardDraft(processId: number) {
            this.processService.discardDraft(processId).then(r =>
                this.updateData()
            );
        }

        public parseTagString(tagString) { // Used by list view to display tags in the name column
            return this.tagParsingService.getTagsArray(tagString);
        };

        public setTagFilter(tag: string) { // Called when a tag is clicked in the list or in the filter men
            if (!this.selectedItems.some(x => x.identifier === tag && x.type === SearchItemType.Tag)) {
                this.selectedItems.push(<ISelectedSearchItem>{ fullName: tag, groupBy: "Tag", identifier: tag, name: tag, title: tag, type: SearchItemType.Tag });
            }

            this.toggleFilterChange(true);
        };

        public setFilterString() {
            this.updateFilterAndSort();
        }

        public setTimelimit() {
            this.processCountsService.getInitialProcessCounts(this.getTimeLimit());
            this.updateData();
        }

        public getInstanceLink(processid: string, stateFilter: string = null) {
            var state = stateFilter != null ? "'" + stateFilter + "'" : null
            var link = `environment.processInstanceList({processId:${processid}, stateFilter: ${state}, page: null, sortColumn: null, sortDirection: null, startTimeLimitUtc: null, endTimeLimitUtc:null, filterString:null})`;
            return link;
        }
        //Works well for all other than sorting triggers. Triggers will now be sorted by converting a array to string. if there are no triggers the triggers array is empty it will be "[]" if not it will be [object Object] and will sort via that..
        //https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
        private sortByProp(prop) {
            return function (a, b) { return (a[prop] != null ? a[prop].toString() : "").localeCompare((b[prop] != null ? b[prop].toString() : ""), undefined, { numeric: true, sensitivity: 'accent' }); };
        }

        private updateFilterAndSort(initialHighlightedProcess?: number) {
            let filteredProcesses = _.filter(this.processes, this.matchesFilter);

            let filteredAndSortedProcesses = filteredProcesses.sort(this.sortByProp(this.orderByField));
            if (this.reverseSort) {
                filteredAndSortedProcesses = filteredAndSortedProcesses.reverse();
            }
            this.totalShownProcessesCount = filteredAndSortedProcesses.length;


            if (initialHighlightedProcess) {
                // select the page with the highlighted process
                let processIndex = _.findIndex(filteredAndSortedProcesses, p => p.id == initialHighlightedProcess);
                if (processIndex >= 0) {
                    this.currentProcessPage = Math.floor(processIndex / this.shownProcessesPerPage) + 1;
                }
            }
            let firstShownItemIndex = (this.currentProcessPage - 1) * this.shownProcessesPerPage;
            if (firstShownItemIndex > filteredAndSortedProcesses.length) {
                // filtered view does not have as many pages as before --> show the first page
                this.currentProcessPage = 0;
                firstShownItemIndex = 0;
            }
            let pageOfProcesses = _.take(_.drop(filteredAndSortedProcesses, firstShownItemIndex), this.shownProcessesPerPage);
            this.shownProcesses = pageOfProcesses;

            this.updateFilterStateToLocation(initialHighlightedProcess);
        }

        private updateFilterStateToLocation(initialHighlightedProcess?: number) {
            this.$state.go("environment", { reload: false }).then(() => {
                this.$state.transitionTo('environment', <IProcessListStateParams>{
                environmentName: this.currentEnvironmentName,
                tag: this.selectedItems.filter(x => x.type === SearchItemType.Tag).map(x => x.identifier).join(","),
                filter: this.filterString,
                processPage: this.currentProcessPage > 1 ? this.currentProcessPage : undefined,
                timelimit: this.timelimitDays,
                highlightProcess: initialHighlightedProcess,
                orderByField: this.orderByField,
                reverseSort: this.reverseSort
            }, { reload: false });
            });
        }

        /**
         * To be used in the process list view, to filter the shown processes by tag and/or filter string
         */
        public matchesFilter = (process: IProcessData) => {

            var matchesFilterString = () => {
                return !this.filterString
                    || process.name.toLowerCase().indexOf(this.filterString.toLowerCase()) >= 0
                    || (process.description && process.description.toLowerCase().indexOf(this.filterString.toLowerCase()) >= 0);
            }

            var matchesSelectedTags = () => {
                var selectedTagItems = this.selectedItems.filter(x => x.type === SearchItemType.Tag);
                return !selectedTagItems || _.intersectionWith(selectedTagItems, this.tagParsingService.getTagsArray(process.tagString), this.tagIntesection).length === selectedTagItems.length;
            }

            var matchedFilteredTasks = () => {
                var selectedTaskItems = this.selectedItems.filter(x => x.type === SearchItemType.Task);
                return !selectedTaskItems || _.intersectionWith(selectedTaskItems, process.usedTasks, this.taskIntesection).length === selectedTaskItems.length;
            }

            return matchesSelectedTags() && matchesFilterString() && matchedFilteredTasks();
        };

        public taskIntesection(arrVal: ISelectedSearchItem, otherVal: IUsedTaskData) {
            return arrVal.identifier === otherVal.uri;
        }
        public tagIntesection(arrVal: ISelectedSearchItem, otherVal: string) {
            return arrVal.identifier === otherVal;
        }

        public openTagModal(processesToTag: IProcessViewData[]) {
            const tagEditorModal = this.$modal.open({
                templateUrl: "tagModalTemplate",
                size: "lg",
                resolve: {
                    processes: () => processesToTag,
                    allTags: () => this.allTags
                },
                controller: "TagModalController as ctrl"
            });

            tagEditorModal.result.then(() => this.updateData());
        }

        public openLogSettingsModal(processData?: IProcessViewData[]) {
            const processes = processData || [];
            const processNames = processes.map((p) => p.name);

            const isEnvironmentLevel = !processData;
            // if environment, or multiple processes selected, just get environment-level settings by setting process guid param to null
            const processToFetchDataFor = processes.length > 0 ? processes[0].uniqueIdentifier : null;

            this.processService.getLogSettings(this.currentEnvironmentName, processToFetchDataFor)
                .then((data) => {
                    if (!data.success) {
                        return; // error, the angular http interceptor should have shown it already
                    }

                    const settings = data.data;
                    const options: ng.ui.bootstrap.IModalSettings = {
                        templateUrl: "LogSettingsModal",
                        windowClass: "default-modal-styles",
                        backdrop: "static",
                        resolve: {
                            processNames: () => processNames,
                            logLevel: () => settings.logLevel,
                            retentionDays: () => settings.historyStorageDays,
                            logTriggerData: () => settings.logTriggerRequestAndResponse
                        },
                        controller: "LogSettingsModalController as ctrl"
                    };

                    return this.$modal.open(options).result.then(
                        (result: LogSettingsModalResult) => {
                            if (isEnvironmentLevel) {
                                this.saveEnvironmentLevelLogSettings(ProcessLoggingLevel[result.logLevel], result.retentionDays, result.logTriggerData);
                            } else {
                                if (result.overrideEnvironmentLogSettings) {
                                    this.saveLogSettings(processes, ProcessLoggingLevel[result.logLevel], result.retentionDays, result.logTriggerData);
                                } else {
                                    // clear all with null values
                                    this.saveLogSettings(processes, null, null, null);
                                }
                            }
                        },
                        (dismissedResult) => { }
                    );
                }).catch((reason) => this.notifications.error(reason));
        }

        private refreshProcesses() {
            _.throttle(() => {
                this.processService.getProcesses(this.processQueryFilter).then(function (data) {

                    var updatedProcesses = data.data.processList;
                    // update existing processes and remove the ones that were not included

                    for (var i = this.processes.length - 1; i >= 0; i--) {
                        var oldProcess = this.processes[i];
                        var updatedProcessIndex = _.findIndex(updatedProcesses, oldProcess);

                        if (updatedProcessIndex < 0) {
                            this.processes.splice(i, 1); // remove the process as it was filtered out from the results
                            continue;
                        }

                        var updatedProcess = updatedProcesses.splice(updatedProcessIndex, 1)[0]; // remove the already processed updated process

                        if (angular.equals(updatedProcess, oldProcess)) {
                            continue;
                        }

                        angular.extend(oldProcess, updatedProcess);
                    }

                    // add the remaining updated processes
                    for (var j = 0; j < updatedProcesses.length; j++) {
                        var newProcess = updatedProcesses[j];
                        this.processes.push(newProcess);
                    }
                });
            }, 1000, { leading: false });
        }

        public updateAgentStatusData() {
            this.$timeout(() => {
                var agentStatuses = this.agentStatuses;

                let currentProcessVersions = this.processes;
                for (var i = 0; i < currentProcessVersions.length; i++) {
                    var processConfiguration = currentProcessVersions[i];

                    var newStatusForProcess = new ProcessStatus();

                    for (var j = 0; j < agentStatuses.length; j++) {
                        var agentStatus = agentStatuses[j];
                        if (agentStatus.processInfos) {
                            var processStatus = agentStatus.processInfos[processConfiguration.uniqueIdentifier];

                            if (processStatus == null || processStatus.version < processConfiguration.version) {
                                newStatusForProcess.deployingToAgents.push(agentStatus.name);
                            }

                            for (let trigger of processConfiguration.triggersUsed) {
                                if (processStatus && processStatus.initializationExceptions && trigger.name) {
                                    trigger.initializationException = processStatus.initializationExceptions[trigger.name.toLowerCase()] || processStatus.initializationExceptions[trigger.name];
                                }

                                if (processStatus == null
                                    || (processConfiguration.triggersActive && !processStatus.triggersActive)
                                    || !_.some(processStatus.triggers, t => t === trigger.name)) {
                                    newStatusForProcess.missingTriggers.push(trigger.name);
                                }

                            }
                        }
                    }

                    newStatusForProcess.isDeploying = newStatusForProcess.deployingToAgents.length > 0;
                    newStatusForProcess.hasMissingTriggers = newStatusForProcess.missingTriggers.length > 0;

                    processConfiguration.status = angular.extend(processConfiguration.status || new ProcessStatus(), newStatusForProcess);
                }
            });

            return true;
        }

        private updateProcessCounts(updatedCounts: IGroupedProcessExecutionCounts) {
            console.debug("Updating counts on process list instances")
            if (this.processes) {
                for (var i = 0; i < this.processes.length; i++) {
                    var process = this.processes[i];
                    var executionCounts = updatedCounts[process.uniqueIdentifier];
                    if (executionCounts) {
                        angular.extend(process, executionCounts);
                    } else {
                        //incase the execution count can not be found we reset the counts to zero for that process
                        var executionCounts: IProcessExecutionCount = {
                            successful: 0,
                            failed: 0,
                            erroredNotAcknowledged: 0
                        }
                        angular.extend(process, executionCounts)
                        // TODO: should we trigger a full refresh?
                    }
                }
            }
        }

    }

    module.controller("ProcessListController", ProcessListController);

    export interface IProcessViewData extends IProcessData {
        checked?: boolean;
        highlight?: boolean;
        status?: ProcessStatus;
        draftId?: number;
        logLevel?: string;
    }

    export interface IDraftViewData extends IDraftData {
        hasProcess?: boolean;
    }

    enum ProcessLoggingLevel {
        Info,
        Error,
        Debug
    }
    interface ISelectedSearchItem {
        name: string;
        fullName: string;
        title: string;
        groupBy: string;
        identifier: string;
        type: SearchItemType;
    }
    enum SearchItemType {
        Task,
        Tag
    }

    interface IProcessListStateParams extends angular.ui.IStateParamsService {
        environmentName: string
        tag?: string;
        processPage?: number;
        filter?: string;
        timelimit?: string;
        highlightProcess?: number;
        orderByField?: string;
        reverseSort?: boolean | string;
    }
}